/**
 * Mobile Bottom Navigation
 *
 * Fidelity-style features:
 * - Fixed bottom position with dark theme
 * - Centered prominent action button (Gym)
 * - Large touch targets (44px minimum)
 * - Visual indicator for active route
 */

import { NavLink } from 'react-router-dom';
import './BottomNav.css';

interface NavItem {
  to: string;
  label: string;
  icon: string;
}

const navItems: NavItem[] = [
  { to: '/schedule', label: 'Schedule', icon: '📅' },
  { to: '/notes', label: 'Notes', icon: '📝' },
  { to: '/gym', label: 'Gym', icon: '💪' },
  { to: '/analytics', label: 'Stats', icon: '📊' },
  { to: '/settings', label: 'Settings', icon: '⚙️' },
];

export function BottomNav(): JSX.Element {
  return (
    <nav className="bottom-nav">
      {navItems.map((item, index) => {
        const isCenterItem = index === 2; // Gym is centered (index 2)
        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `bottom-nav__item ${isCenterItem ? 'bottom-nav__item--center' : ''} ${
                isActive ? 'bottom-nav__item--active' : ''
              }`
            }
          >
            {isCenterItem ? (
              <div className="bottom-nav__center-button">
                <span className="bottom-nav__icon">{item.icon}</span>
              </div>
            ) : (
              <span className="bottom-nav__icon">{item.icon}</span>
            )}
            <span className="bottom-nav__label">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
